import React from 'react'
import Sidebar from '../components/Sidebar'

const Supplier = () => {
  return (
    <>

    <div>
      Supplier
    </div>
    </>
  )
}

export default Supplier
